import { useMediaById } from "@coworker/app/src/components/RoomSettings/hooks/useMediaById";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import RecursiveTextCardFragment, {
  type RecursiveTextCardFragmentConfigProps,
} from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/RecursiveTextCardFragment/RecursiveTextCardFragment";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type MediaRecursiveTextCardFragmentConfigProps =
  RecursiveTextCardFragmentConfigProps;

type MediaRecursiveTextCardFragmentProps = {
  configProps: MediaRecursiveTextCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function MediaRecursiveTextCardFragment({
  configProps,
  commonProps,
}: MediaRecursiveTextCardFragmentProps) {
  const { task } = commonProps;
  const mediaId = getTypedValue<string>(getByPath(task, "details.media_id"));

  const { data: mediaResponse, isLoading: isMediaLoading } = useMediaById(
    isLoading(mediaId) ? undefined : mediaId
  );

  if (isLoading(task) || isMediaLoading) {
    return <LoadingCardFragment />;
  }

  // Inject media_name into details so steps with field "details.media_name" resolve correctly
  const taskWithMediaName: Task = {
    ...(task as Task),
    details: {
      ...(task as Task).details,
      media_name: mediaResponse?.media?.name ?? "",
    },
  };

  return (
    <RecursiveTextCardFragment
      configProps={configProps}
      commonProps={{ ...commonProps, task: taskWithMediaName }}
    />
  );
}

export default MediaRecursiveTextCardFragment;
